import { ImageSlide } from '@modules/husleie-framework/src/types/Swiper.entity';

enum UtilityTypeEnum {
  ELECTRICITY = 'ELECTRICITY',
  HOT_WATER = 'HOT_WATER',
  COLD_WATER = 'COLD_WATER',
  GAS = 'GAS',
  HEATING = 'HEATING',
}
type UtilityType =
  | UtilityTypeEnum.ELECTRICITY
  | UtilityTypeEnum.HOT_WATER
  | UtilityTypeEnum.COLD_WATER
  | UtilityTypeEnum.GAS
  | UtilityTypeEnum.HEATING;

enum UtilityStatusEnum {
  RELEVANT = 'RELEVANT',
  NOT_RELEVANT = 'NOT_RELEVANT',
}
type UtilityStatus = UtilityStatusEnum.RELEVANT | UtilityStatusEnum.NOT_RELEVANT;

interface UtilityMeterReading {
  date?: string;
  value?: number;
  images?: ImageSlide[];
  comment?: string;
}

interface UtilityMeter {
  number?: string;
  reading?: UtilityMeterReading;
}

interface Utility {
  type: UtilityType;
  state: UtilityStatus;
  meter?: UtilityMeter;
}

export { Utility, UtilityType, UtilityTypeEnum, UtilityStatus, UtilityStatusEnum, UtilityMeter, UtilityMeterReading };
